import { eventSlugnameTrim } from './format';

export const errorInput = ({ errorInputs, input = {} }) => {
  errorInputs = { ...errorInputs, [input.name]: !Boolean(input.value) };
  return errorInputs;
};

export const deleteForm = async ({ Swal, subtitle = '', func = () => {} }) => {
  const { value: text } = await Swal.fire({
    title: 'Eliminar',
    input: 'textarea',
    text: subtitle,
    inputPlaceholder: 'Escribe la razón por la que vas a eliminar este campo',
    inputAttributes: {
      'aria-label': 'Razón de eliminación',
    },
    showCancelButton: true,
  });

  const successAlert = () => Swal.fire('Eliminado exitosamente');

  if (text) await func({ text, successAlert });
};

// Search dropdowns blur the input before the option click, so onChange never runs.
// Commit the option on mouse down and return the props every Select can spread.
export const searchSelectProps = ({
  name,
  options = [],
  handler,
  search = true,
  selectOnBlur,
  ...rest
}) => ({
  name,
  search,
  onChange: handler,
  ...('value' in rest ? { value: rest.value } : {}),
  ...(search
    ? {
        selectOnBlur: selectOnBlur ?? false,
        options: options.map((opt) => ({
          ...opt,
          onMouseDown: (event) => {
            event.preventDefault();
            handler?.(event, { name, value: opt.value });
          },
        })),
      }
    : { options, ...(selectOnBlur !== undefined ? { selectOnBlur } : {}) }),
});

export const selectArea = ({
  Select,
  options,
  label,
  name,
  value,
  loading = false,
  errorInputs = {},
  handler,
  selectOnBlur,
}) => (
  <Select
    placeholder={label}
    style={{
      display: 'block',
      margin: ' 7px 0',
    }}
    className={errorInputs[name] ? 'error' : ''}
    id={name}
    loading={loading}
    {...searchSelectProps({
      name,
      handler,
      value,
      selectOnBlur,
      options: options.map((a) => ({ key: a, value: a, text: a })),
    })}
  />
);

export const textArea = ({
  TextArea,
  label,
  name,
  disabled = false,
  value,
  style = {},
  handler,
  defaultValue,
  loading = false,
  errorInputs = {},
}) => {
  return (
    <div id="transversal">
      <TextArea
        placeholder={label}
        name={name}
        id={name}
        error={errorInputs[name]}
        value={value}
        defaultValue={defaultValue}
        disabled={disabled}
        style={{
          ...style,
          padding: '10px',
          maxWidth: '700px',
          minWidth: '80%',
        }}
        loading={loading}
        onChange={handler}
        className={`Registration__input Registration__input-${name} ${
          errorInputs[name] ? 'error' : ''
        }`}
      />
    </div>
  );
};

export const formSelect = ({
  Select,
  name,
  label,
  value,
  errorInputs = {},
  disabled = false,
  options,
  handler,
}) => (
  <Select
    placeholder={label}
    className={errorInputs[name] ? 'error' : ''}
    disabled={disabled}
    id={name}
    {...searchSelectProps({
      name,
      handler,
      value,
      options: options.map((a) => ({ key: a, value: a, text: a })),
    })}
  />
);

export const formLabel = (id, label, errorInputs = {}) => (
  <label
    htmlFor={id}
    style={{ margin: 0, color: errorInputs?.[id] ? 'red' : '', display: 'block' }}
  >
    {label} {!!errorInputs[id] && '(Campo requerido)'}
  </label>
);

export const formSelectService = ({
  Select,
  name,
  label,
  value,
  loading = false,
  options,
  style = {},
  handler,
  disabled,
  errorInputs = {},
  search = true,
  clearable = false,
  selectOnBlur,
}) => (
  <Select
    placeholder={label}
    disabled={disabled}
    id={name}
    loading={loading}
    style={style}
    clearable={clearable}
    className={`Registration__input Registration__input-${name} ${
      errorInputs[name] ? 'error' : ''
    }`}
    {...searchSelectProps({
      name,
      handler,
      value,
      search,
      selectOnBlur,
      options: options.map((opt) => {
        if (opt && typeof opt === 'object') {
          return {
            key: opt.key ?? opt.value,
            value: opt.value,
            text: eventSlugnameTrim(opt.text ?? opt.value),
          };
        }
        return { key: opt, value: opt, text: eventSlugnameTrim(opt) };
      }),
    })}
  />
);

export const formInput = ({
  Input,
  label,
  name,
  disabled = false,
  value,
  handler,
  loading = false,
  defaultValue,
  errorInputs = {},
  type = 'text',
}) => (
  <Input
    placeholder={label}
    name={name}
    error={errorInputs[name]}
    value={value}
    disabled={disabled}
    loading={loading}
    onChange={handler}
    defaultValue={defaultValue}
    type={type}
    className={`Registration__input Registration__input-${name} ${
      errorInputs[name] ? 'error' : ''
    }`}
  />
);
